import { action, computed, observable } from "mobx";
import { UserAuthStore } from "./UserAuthStore";
import { UserTypes, isGamesTheme } from "@utils";
import { AccountVerificationStatus } from "@api-types/user/LoginResponseDto";
import { THEME_SETTINGS } from "@theme-settings";

class RequiredUserActionsStore {
	private userAuthStore: UserAuthStore;
	@observable isActive: boolean = false;

	constructor(userAuthStore: UserAuthStore) {
		this.userAuthStore = userAuthStore;
	}

	@computed get userActionStatus() {
		if (!this.userAuthStore.isLoggedIn) {
			return false;
		}

		const userType = this.userAuthStore.getWalletOwnerByWalletId(
			this.userAuthStore.activeWalletId
		);

		const user =
			UserTypes.PRIMARY == userType
				? this.userAuthStore.user
				: this.userAuthStore.secondaryUser;

		if (
			this.userAuthStore.isInternetUser &&
			THEME_SETTINGS.isAccountVerificationSectionEnabled
		) {
			if (
				this.userAuthStore.onlineUser?.accountVerificationStatus !==
					AccountVerificationStatus.FullyVerified &&
				!this.userAuthStore.user?.isRegisteredWithExternalProvider
			) {
				return true;
			}
		}
		const primaryUser = this.userAuthStore.user;

		if (!isGamesTheme()) {
			if (
				(primaryUser && primaryUser?.userDocumentDateExpired) ||
				primaryUser?.userDocumentDateExpiresSoon ||
				primaryUser?.userDocumentDateNotSet
			) {
				return true;
			}
		}

		const secondaryUser = this.userAuthStore.secondaryUser;

		if (!isGamesTheme()) {
			if (secondaryUser) {
				if (this.userAuthStore.onlineUser?.depositLimitUpdate) {
					return true;
				}
			} else if (primaryUser && primaryUser?.depositLimitUpdate) {
				return true;
			}
		}

		if (!isGamesTheme()) {
			if (
				(secondaryUser && secondaryUser?.userDocumentDateExpired) ||
				secondaryUser?.userDocumentDateExpiresSoon ||
				secondaryUser?.userDocumentDateNotSet
			) {
				return true;
			}
		}

		if (user?.isBettingDisabled && !isGamesTheme()) {
			return true;
		}

		if (!isGamesTheme()) {
			if (
				primaryUser?.userAccountDeactivationGracePeriodExpirationDate ||
				secondaryUser?.userAccountDeactivationGracePeriodExpirationDate
			) {
				return true;
			}
		}

		if (primaryUser?.isAnnualIncomeRequired) {
			return true;
		}

		if (
			user?.isCreditRatingCheckRequired &&
			THEME_SETTINGS.isCreditRatingCheckEnabled
		) {
			return true;
		}

		return false;
	}

	@action.bound
	showPopup() {
		this.isActive = true;
	}

	@action.bound
	hidePopup() {
		this.isActive = false;
	}
}

export default RequiredUserActionsStore;
